import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from "../../services/BackendServices";
import { CircularProgress, Typography, Box, TextField, Button, Stack } from '@mui/material';

const Logo = require("../../assets/images/logoTrixie.png");

const ConfirmEmail = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [userId, setUserId] = useState('');
  const [verificationToken, setVerificationToken] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const userIdFromUrl = queryParams.get('userId');
    const tokenFromUrl = queryParams.get('token');

    if (userIdFromUrl && tokenFromUrl) {
      setUserId(userIdFromUrl);
      setVerificationToken(tokenFromUrl);
    } else {
      setMessage('Enlace de confirmación inválido.');
    }
  }, [location.search]);

  const confirmarEmail = async () => {
    setLoading(true);
    try {
      const response = await api.SecurityServices.verifyAccount({
        params: {
          verificationToken,
          verificationCode,
          userId,
        },
      });
      setMessage(response.data.message);
      if (response.data.status === 200) {
        setIsConfirmed(true);
      }
    } catch (error) {
      setMessage('Falló la confirmación del correo. Por favor, intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
      {loading ? (
        <CircularProgress />
      ) : (
        <Stack spacing={3} alignItems="center" width="300px">
          <img src={Logo} alt="Logo Trixie" style={{ width: '80%', marginBottom: '20px' }} />
          <Typography variant="h6" align="center">
            {message || 'Por favor, ingresa el código enviado a tu correo electrónico.'}
          </Typography>
          <TextField
            label="Ingresar Código"
            variant="outlined"
            fullWidth
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            margin="normal"
            disabled={isConfirmed}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={confirmarEmail}
            fullWidth
            disabled={!verificationCode || isConfirmed}
          >
            Confirmar Correo
          </Button>
          {isConfirmed && (
            <Button variant="outlined" color="secondary" fullWidth onClick={() => navigate('/')}>
              Ir al Inicio
            </Button>
          )}
        </Stack>
      )}
    </Box>
  );
};

export default ConfirmEmail;
